export default __webpack_public_path__ + "static/media/noFilesAdmin.10d52bd5.png";